<div nz-row [nzGutter]="grid.gutter" nzAlign="middle">
  @for (col of cols || []; track col) {
    <div
      [class.bt-row-hide]="col && !col.show()"
      nz-col
      [nzXs]="col.grid?.xs || grid.xs"
      [nzSm]="col.grid?.sm || grid.sm"
      [nzMd]="col.grid?.md || grid.md"
      [nzLg]="col.grid?.lg || grid.lg"
      [nzXl]="col.grid?.xl || grid.xl"
      [nzXXl]="col.grid?.xxl || grid.xxl"
      >
      <nz-form-item>
        @if (col.label) {
          <nz-form-label>
            <span class="text-bold">{{ col.label | actrans }}</span>
            <!-- <i
            class="mkInfoIcon"
            *ngIf="col.mkInfo"
            nz-icon [nzType]="'info-circle'"
            nz-tooltip
            [nzTooltipTitle]="mkInfoTemplate"
            >
            <ng-template #mkInfoTemplate>
              <span class="text-sm" [innerHtml]="col.mkInfo | actrans"></span>
            </ng-template>
          </i> -->
        </nz-form-label>
      }
      <nz-form-control [class]="col.css || ''">
        @if (col.value) {
          <div>
            @switch (col.type) {
              @case ('json') {
                <div>
                  <pre>{{ col.value}}</pre>
                </div>
              }
              @case ('link') {
                <div>
                  <label>
                    <a
                      [class]="col.css || ''"
                      [routerLink]="col.data.routerLink"
                      [queryParams]="col.data.queryParams || {}"
                      [innerHtml]="col.value | trusthtml"
                      [target]="col.data.newWindow ? '_blank' : '_self'"
                    ></a>
                  </label>
                </div>
              }
              @default {
                <label [innerHtml]="col.value | trusthtml" >
                </label>
              }
            }
          </div>
        }
      </nz-form-control>
    </nz-form-item>
  </div>
}
</div>
